<template>
  <div>
    <vs-table ref="table" :data="students">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <vs-collapse style="width: 100%">
          <vs-collapse-item open icon-pack="feather" icon-arrow="icon-arrow-down">
            <div slot="header">
              Filter Students
              <vs-chip color="primary" v-if="numFilters > 0">{{ numFilters }}</vs-chip>
            </div>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="4"
                vs-sm="6"
                vs-xs="12"
              >
                <vs-input
                  class="w-full mb-base mx-1"
                  label="Search by name or email"
                  v-model="filters.searchstr"
                ></vs-input>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="4"
                vs-sm="6"
                vs-xs="12"
              >
                <select
                  class="defaultselect w-full mb-base mx-1"
                  v-model="filters.year"
                  aria-label="Year Group"
                >
                  <option value="">All Groups</option>
                  <option
                    :key="index"
                    :value="item.id"
                    v-for="(item, index) in student_groups"
                    :selected="filters.year == item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </vs-col>
            </vs-row>
            <vs-button class="mx-2" @click="filterStudents">Search</vs-button>
            <vs-button class="mx-2" color="success" @click="clearFilters">Clear</vs-button>
          </vs-collapse-item>
        </vs-collapse>
      </div>

      <template slot="thead">
        <vs-th scope="col" width="5%">#</vs-th>
        <vs-th scope="col" sort-key="name" width="45%">Name</vs-th>
        <vs-th scope="col" sort-key="email" width="25%">E-mail</vs-th>
        <vs-th scope="col" sort-key="order_status" width="15%">Year</vs-th>
        <vs-th scope="col" width="10%">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            :class="{ hoverFlat: tr.type == 'letter' }"
          >
            <template v-if="tr.type == 'letter'">
              <vs-th scope="col" colspan="6">
                <p class="letter-row">
                  {{ tr.letter }}
                </p>
              </vs-th>
            </template>
            <template v-else>
              <vs-td>
                <input type="checkbox" v-model="selected" :value="tr.student_id" />
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.student_surname }}, {{ tr.student_name }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-category">{{ tr.student_email }}</p>
              </vs-td>
              <vs-td>
                <p class="product-price">{{ tr.student_group_name }}</p>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="editData(tr.student_id)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="deleteData(tr.student_id)"
                />
              </vs-td>
            </template>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <div class="flex flex-wrap-reverse items-center flex-grow justify-between mt-10">
      <div class="flex flex-wrap-reverse items-center data-list-btn-container">
        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">
          <div
            class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full"
          >
            <span class="mr-2">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="deleteSelectedStudents">
              <span class="flex items-center">
                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Delete</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="moveSelectedStudents">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Move</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <!-- ADD NEW -->
        <router-link to="/teacher/students/add">
          <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </router-link>
      </div>
    </div>
    <vs-prompt
      @cancel="closeMovePopup"
      @accept="moveStudents"
      @close="closeMovePopup"
      :active.sync="activeMovePrompt"
    >
      <div class="con-exemple-prompt">
        <span>Select Group</span>
        <vs-select class="w-full mb-base mx-1" label="Select Year Group" v-model="moveStudentsTo">
          <vs-select-item value="" text="Please Select" />
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.name"
            v-for="(item, index) in student_groups"
          />
        </vs-select>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import studentMixin from '@/mixins/student';
import theApi from '@/mixins/theApi';
import store from '@/store/store';

export default {
  data() {
    return {
      filters: {
        searchstr: '',
        year: '',
        status: '',
      },
      student_groups: studentMixin.methods.getGroups(),
      studentIdToDelete: null,
      students: [],
      itemsPerPage: 4,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      selected: [],
      moveStudentsTo: '',
      activeMovePrompt: false,
    };
  },
  computed: {
    numFilters() {
      let numFilters = 0;
      if (this.filters.searchstr !== '') numFilters++;
      if (this.filters.status !== '') numFilters++;
      if (this.filters.year !== '') numFilters++;

      return numFilters;
    },
    teacherAccessType() {
      return store.getters['authTeacher/accessType'];
    },
  },
  methods: {
    async loadStudents() {
      const formData = new FormData();
      for (const [key, value] of Object.entries(this.filters)) {
        formData.append(key, value);
      }

      theApi.methods.makeCall(true, 'students/load', 'post', formData).then(
        (data) => {
          this.students = data.students;
        },
        () => {},
      );
    },
    editData(student_id) {
      this.$router.replace('/teacher/students/edit/' + student_id);
    },
    deleteData(student_id) {
      this.studentIdToDelete = student_id;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete this student?',
        accept: this.acceptDelete,
      });
    },
    async acceptDelete() {
      const student_id = this.studentIdToDelete;

      theApi.methods.makeCall(false, 'students/delete/' + student_id, 'post').then(
        (data) => {
          if (data.status == 'OK') {
            let new_students = this.students.filter(function (item) {
              return item.student_id !== student_id;
            });
            this.students = new_students;
            this.studentIdToDelete = null;
          }
        },
        () => {},
      );
    },
    filterStudents() {
      this.loadStudents();
    },
    clearFilters() {
      this.filters = {
        searchstr: '',
        year: '',
        status: '',
      };
      this.loadStudents();
    },
    deleteSelectedStudents() {
      if (this.selected.length === 0) {
        this.$vs.dialog({
          color: 'danger',
          title: `Please select students`,
          text: 'Please select at least one student to delete.',
        });
      } else {
        const vm = this;
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm Students Delete`,
          text: 'Are you sure you want to delete selected students?.',
          accept: async function () {
            const formData = new FormData();
            formData.append('student_ids', vm.selected);
            theApi.methods
              .makeCall(
                false,
                'students/delete',
                'post',
                formData,
                'Students deleted successfully',
                true,
              )
              .then(
                () => {
                  vm.selected = [];
                  this.loadStudents();
                },
                () => {},
              );
          },
        });
      }
    },
    moveSelectedStudents() {
      if (this.selected.length === 0) {
        this.$vs.dialog({
          color: 'danger',
          title: `Please select students`,
          text: 'Please select at least one student to move.',
        });
      } else {
        this.activeMovePrompt = true;
      }
    },
    async moveStudents() {
      const formData = new FormData();
      formData.append('student_ids', this.selected);
      formData.append('new_student_group', this.moveStudentsTo);

      theApi.methods
        .makeCall(false, 'students/move', 'post', formData, 'Students moved successfully', true)
        .then(
          () => {
            this.selected = [];
            this.loadStudents();

            this.closeMovePopup();
          },
          () => {
            this.closeMovePopup();
          },
        );
    },
    closeMovePopup() {
      this.moveStudentsTo = '';
      this.activeMovePrompt = false;
    },
  },
  mounted() {
    if (this.teacherAccessType != 2) {
      this.$router.push('/teacher/dashboard');
    } else {
      this.loadStudents();
    }
  },
};
</script>

<style scoped>
p.letter-row {
  font-size: 15px;
  padding: 5px;
}
tr.hoverFlat {
  border-bottom: 1px solid #f8f8f8;
}
</style>
